import { render, staticRenderFns } from "./AddOtherServiceDialog.vue?vue&type=template&id=3c9229e4&scoped=true"
import script from "./AddOtherServiceDialog.vue?vue&type=script&lang=js"
export * from "./AddOtherServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOtherServiceDialog.vue?vue&type=style&index=0&id=3c9229e4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9229e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9229e4')) {
      api.createRecord('3c9229e4', component.options)
    } else {
      api.reload('3c9229e4', component.options)
    }
    module.hot.accept("./AddOtherServiceDialog.vue?vue&type=template&id=3c9229e4&scoped=true", function () {
      api.rerender('3c9229e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/components/AddOtherServiceDialog.vue"
export default component.exports